import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const SELECTS = [
  ["faixa_etaria", "Faixa etária (opcional)", false],
  ["setor", "Setor", true],
  ["situacao", "Situação", true],
  ["papel", "Seu papel no negócio", true],
  ["tempo_operacao", "Tempo de operação", true],
];

const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-2 block text-sm font-medium text-stone-700">{label}</span>
    {children}
  </label>
);

export default function Registration({ session, options, onDone }) {
  const [f, setF] = useState({ nome: "", email: session.email_prefill || "", whatsapp: "", negocio: "", faixa_etaria: "", setor: "", situacao: "", papel: "", tempo_operacao: "" });
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) return toast.error("Para continuar, confirme o consentimento de uso dos dados.");
    setBusy(true);
    try {
      const r = await api.put("/session/profile", { data: f, consent });
      onDone(r.data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="mx-auto max-w-xl px-5 pb-20 pt-4 fade-up" data-testid="registration-form">
      <span className="eyebrow">Antes de começar</span>
      <h1 className="mt-4 text-3xl text-stone-900 sm:text-4xl">Conte um pouco sobre você e seu negócio</h1>
      <p className="mt-3 text-stone-600">Leva cerca de dois minutos. Não pedimos CPF, CNPJ, endereço ou dados financeiros detalhados.</p>
      <div className="mt-8 space-y-5">
        <Field label="Nome completo"><input required className="field" value={f.nome} onChange={set("nome")} data-testid="reg-nome-input" autoComplete="name" /></Field>
        <Field label="E-mail"><input required type="email" className="field" value={f.email} onChange={set("email")} data-testid="reg-email-input" autoComplete="email" /></Field>
        <Field label="WhatsApp (com DDD)"><input required inputMode="tel" className="field" placeholder="(11) 90000-0000" value={f.whatsapp} onChange={set("whatsapp")} data-testid="reg-whatsapp-input" /></Field>
        <Field label="Nome do negócio ou atividade"><input required className="field" value={f.negocio} onChange={set("negocio")} data-testid="reg-negocio-input" /></Field>
        {SELECTS.map(([k, label, req]) => (
          <Field key={k} label={label}>
            <select required={req} className="field appearance-none" value={f[k]} onChange={set(k)} data-testid={`reg-${k}-select`}>
              <option value="">Selecione…</option>
              {options[k].map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </Field>
        ))}
      </div>
      <div className="mt-8 rounded-2xl border bg-white/70 p-5 text-sm leading-relaxed text-stone-600" data-testid="reg-privacy-notice">
        Seus dados e respostas serão usados exclusivamente para gerar seu Mapa da Virada e para contato da Escola da Virada 360° sobre ele. Não vendemos seus dados. Você pode solicitar a exclusão a qualquer momento. Veja a <Link to="/privacidade" target="_blank" className="underline">Política de privacidade</Link>.
        <label className="mt-4 flex cursor-pointer items-start gap-3 text-stone-800">
          <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-1 h-5 w-5 accent-[#1c1917]" data-testid="reg-consent-checkbox" />
          <span>Li e concordo com o tratamento dos meus dados para esta finalidade.</span>
        </label>
      </div>
      <button type="submit" disabled={busy} className="btn-primary mt-8 w-full" data-testid="reg-submit-button">
        {busy ? "Salvando…" : "Começar meu Mapa"}
      </button>
    </form>
  );
}
